"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var button_styles = __importStar(require("@components/Buttons/Button.module.scss"));
var modal_styles = __importStar(require("./Modal.module.scss"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("@store/slices/modalSlice");
var useKeyEnter_1 = require("@hooks/useKeyEnter");
function InfoModal() {
    var text = (0, react_redux_1.useSelector)(function (state) { return state.modalSlice; }).text;
    var dispatch = (0, react_redux_1.useDispatch)();
    function handleClose() {
        dispatch((0, modalSlice_1.closeModal)());
    }
    (0, useKeyEnter_1.useKeyEnter)(function () { return handleClose(); });
    return ((0, jsx_runtime_1.jsxs)("div", { className: modal_styles.submit_form, children: [(0, jsx_runtime_1.jsx)("h2", { children: text }), (0, jsx_runtime_1.jsx)("div", { className: modal_styles.form_footer, children: (0, jsx_runtime_1.jsx)("button", { "data-testid": "close_modal", type: "button", className: button_styles.create_btn, onClick: handleClose, children: "Close" }) })] }));
}
exports.default = InfoModal;
